module.exports = __webpack_public_path__ + "img/shizi_hover.db481cbd.png";